import {
  Box,
  Breadcrumbs,
  Button,
  Grid,
  Link,
  Typography,
} from "@mui/material";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import PatientHeader from "../../PatientHeader/containers/index";
import DisciplineList from "../Container/DisciplineList";
import AuthorizationDetailsTabs from "../../AuthorizationDetailsTab/components/AuthorizationDetailsTabs";
import { BackBtn, HeaderText } from "../../PatientHeader/style";
import colors from "../../../styles/colors/colors";
import fontWeight from "../../../styles/mui/fontWeight";
import { breadcrumbLinkStyle, breadcrumbsStyle } from "../Style/DisciplineStyle";

const AuthDetails = () => {
  const navigate = useNavigate();
  const handleBackOp = () => {
    navigate(-1);
  };
  return (
    <Grid container m={"1rem 2rem"}>
      <Grid size={12}>
        <Breadcrumbs
          separator={<NavigateNextIcon sx={{ fontSize: 16 }} />}
          aria-label="breadcrumb"
          sx={breadcrumbsStyle}
        >
          <Link
            href="#"
            underline="hover"
            color={colors.brand.primary}
            sx={breadcrumbLinkStyle}
            onClick={(e) => {
               e.preventDefault();
               handleBackOp();
             }}
          >
            Patient Details
          </Link>

          <Typography
            color={colors.fonts[6]}
            sx={{ fontWeight: fontWeight.Weight[6] }}
          >
            Authorization details
          </Typography>
        </Breadcrumbs>

        <Box display="flex" alignItems={"center"}>
          <Button
            variant="contained"
            sx={BackBtn}
            onClick={handleBackOp}
            data-testid="auth-details-back-button"
          >
            BACK
          </Button>
          <Typography
            variant="h4"
            fontWeight={fontWeight.Weight[6]}
            color={colors.black[2]}
            sx={HeaderText}
          >
            AUTHORIZATION DETAILS
          </Typography>
        </Box>
        <PatientHeader />
      </Grid>
      <Grid size={12}>
        <AuthorizationDetailsTabs />
      </Grid>
      <Grid size={12}>
        <DisciplineList />
      </Grid>
    </Grid>
  );
};

export default AuthDetails;
